import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    appBar: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        backgroundColor: "black",
        padding: "10px 20px",
        borderBottom: "1.5px solid white",
    },
    brandContainer: {
        width: "75%",
        textAlign: "left",
        paddingLeft: "40px",
    },
    heading: {
        textDecoration: "none",
        color: "white",
        fontSize: "1.3rem",
        fontFamily: "Garamond",
    },
    pages: {
        textDecoration: "none",
        color: "white",
        fontSize: "1.3rem",
        fontFamily: "Garamond",
        padding: "0px 10px",
        "&:hover": {
            textDecoration: "underline",
            textDecorationThickness: "0.1rem",
        },
    },
    toolbar: {
        width: "25%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
    },
}));

export default useStyles;
